import React from 'react';
import { translate } from 'translations';
import '@pqina/flip/dist/flip.min.css';
import styles from './eventTimeLabels.module.scss';

interface EventTimeLabelsProps {
    showHours: boolean;
}

const EventTimeLabels: React.FC<EventTimeLabelsProps> = ({ showHours }) => {
    return (
        <div className={styles['time-text-wrapper']}>
            {showHours && <div className={styles['time-text']}>{translate('Hour')}</div>}
            <div className={styles['time-text']}>{translate('Min')}</div>
            {!showHours && <div className={styles['time-text']}>{translate('Sec')}</div>}
        </div>
    );
};

export default EventTimeLabels;
